export * from './make-table-dispatcher';
